import { render, staticRenderFns } from "./NameTakeOutUser.vue?vue&type=template&id=20c2ebec&scoped=true&"
import script from "./NameTakeOutUser.vue?vue&type=script&lang=js&"
export * from "./NameTakeOutUser.vue?vue&type=script&lang=js&"
import style0 from "./NameTakeOutUser.vue?vue&type=style&index=0&id=20c2ebec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c2ebec",
  null
  
)

export default component.exports